import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { KeyValue } from '@angular/common';
import {
  IApiResponse,
  IFilterPaginationDto,
  ITipDto,
  ITipSettingDto,
} from '../models';

@Injectable()
export class TipService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getTipList(model: IFilterPaginationDto): Observable<ITipDto[]> {
    return this.post(`admin/tip/list`, model);
  }

  public changeTipStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/tip/${id}`, null);
  }

  public addTip(model: ITipDto): Observable<IApiResponse<boolean>> {
    return this.post(`admin/tip/save`, model);
  }

  public changeDefaultStatus(
    id: number,
    model: KeyValue<number, boolean>
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/tip/default/${id}`, model);
  }

  public deleteTip(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/tip/${id}`);
  }

  public updateTipOrder(
    model: KeyValue<number, number>[]
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/tip/order`, model);
  }

  public getTipSetting(id: number): Observable<ITipSettingDto> {
    return this.get(`admin/tip/setting/${id}`);
  }

  public updateTipSetting(
    model: ITipSettingDto
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/tip/setting`, model);
  }
}
